<template>
    <div class="draggable card mb-3 border-">
        <!-- Card Header-->
        <div class="card-header object-hover">
            <span class="float-right drag-handle drag-handle-fixed ml-3"> <fa-icon icon="grip-lines"/></span>
            <span v-if="published" class="float-right badge badge-success">
                <fa-icon icon="check"/>
                {{ $t('episode.published') }}
            </span>
            <span v-else-if="episode.publish.publish_date" class="float-right badge badge-warning">
                <fa-icon icon="clock"/>
                {{ scheduled }}
            </span>
            <span v-else class="float-right badge badge-danger">
                <fa-icon icon="ban"/>
                {{ $t('episode.unpublished') }}
            </span>
            <div class="mb-0">
                {{ index + 1 }}. {{ episode.name || $t('episode.untitled') }}
                <a :href="getUrl('edit')" class="small on-object-hover ml-2" @click="saveSnick($event, 'edit')">
                    <fa-icon icon="pen"/>
                    {{ $t('interface.btnEdit') }}</a>
                <span class="small on-object-hover ml-2 btn-link clickable" @click="expanded=!expanded"><fa-icon
                    icon="cog"/> {{ $t('interface.btnSettings') }}</span>

            </div>
        </div>

        <!-- Card Body -->
        <div v-if="expanded" class="card-body">
            <!-- Publish Options -->
            <fa-icon
                :icon="published ? 'toggle-on' : 'toggle-off'"
                class="clickable"
                v-on:click="togglePublished"
            ></fa-icon>

            Published
            <autopublish-widget
                :publish-date="episode.publish.publish_date"
                :published="published"
                @autopublish="publish"
            />

            <!-- Audio File -->
            <div v-bind:class="{'compact': showAudioUpload }">
                <input :value="episode.id"
                       name="episode[]"
                       type="hidden"
                />
            </div>
            <div v-if="showAudioUpload" class="pt-3 position-relative" v-bind:class="{ 'pb-3' : lastEpisode}">
                <fa-icon icon="file-audio"/>
                <audio-upload
                    :compactLayout=true
                    :episode="episode"
                    :episodeId="episode.id"
                    :extensions="extensions"
                    :hasAudioFile="hasAudioFile"
                    :removeUploadButtonAlert="removeMessages"
                    :setErrorMessage="displayAudioError"
                    :setSuccessMessage="displayAudioSuccess"
                    :snickId="snickId"
                ></audio-upload>
                <span
                    v-if="errorMessage"
                    class="message position-absolute text-danger"
                    v-bind:class="{ '-last' : lastEpisode}"
                >
                    {{ errorMessage }}
                </span>
                <span
                    v-if="successMessage"
                    class="message position-absolute text-success"
                    v-bind:class="{ '-last' : lastEpisode}"
                >
                    {{ successMessage }}
                </span>
            </div>

            <!-- Delete -->
            <a class="btn btn-danger text-white" v-on:click="$emit('delete-episode', index)">
                <fa-icon icon="trash-alt"/>
                Delete</a>
        </div>
    </div>
</template>

<script>
import AudioUpload from '../EpisodeEditor/AudioUpload';
import moment from 'moment-timezone';

export default {
    props: ['episode', 'index', 'snickId', 'extensions', 'lastEpisode', 'canPublish'],
    components: {
        AudioUpload,
    },
    methods: {
        saveSnick(e, endpoint) {
            e.preventDefault();
            const form = $('main  form');

            const url = new URL(form.attr('action'));

            form.attr('action', url.origin + url.pathname + '?redirect=' + this.getUrl(endpoint)).submit();
        },
        getUrl: function (endpoint) {
            endpoint = `/${endpoint}` || '';
            return `/docus/${this.snickId}/episodes/${this.$vnode.key}${endpoint}`;
        },
        displayAudioError: function (message) {
            this.errorMessage = message;
            setTimeout(() => {
                this.errorMessage = null;
            }, 5000);
        },
        displayAudioSuccess: function (message) {
            this.successMessage = message;
            setTimeout(() => {
                this.successMessage = null;
            }, 5000);
        },
        removeMessages: function () {
            this.errorMessage = false;
            this.successMessage = false;
        },
        togglePublished: function () {
            this.published = !this.published;
            this.publish();
        },
        publish: function (schedule) {
            const url = `/docus/${this.episode.story.id}/episodes/${this.episode.id}/publish`;
            const data = {
                published: this.published,
                scheduled_date: schedule
            };

            axios.post(url, data).then((response) => {
                this.published = response.data.published;
                this.episode.publish.publish_date = response.data.publish.publish_date;
            }).catch((err) => {
                console.error(err);
            });
        },
    },
    computed: {
        showAudioUpload: function () {
            // Show audio upload widget for snicks which has audio
            return this.types.indexOf('audio') >= 0;
        },
        hasAudioFile: function () {
            return this.episode.duration > 0 && this.episode.audio_track.length > 0;
        },
        scheduled: function () {
            const date = moment.tz(this.episode.publish.publish_date, 'GMT')
                .tz('Europe/Stockholm')
                .format('YYYY-MM-DD HH:mm');
            return date;
        }
    },
    data: function () {
        return {
            expanded: false,
            errorMessage: false,
            successMessage: false,
            types: this.episode.story.type.split('+'),
            published: this.episode.published,
        }
    },
    mounted() {
        const typeSelect = document.querySelector('#frm-type');
        if (typeSelect) {
            typeSelect.addEventListener('change', () => {
                this.types = typeSelect.value;
            })
        }
    }
};

</script>
<style>
.message {
    left: 20px;
    bottom: -10px;
}

.message.-last {
    bottom: -2px;
}
</style>
